export function onFocusButton(branding, evt) {
  if (window[branding]) {
    evt.target.style.opacity = 0.9
  }
}

export function onBlurButton(branding, evt) {
  if (window[branding]) {
    evt.target.style.background = window[branding].alternateColor
    evt.target.style.opacity = 1.0
  }
}

export function onFocusInput(branding, evt) {
  if (window[branding]) {
    evt.target.style.borderColor = window[branding].alternateColor
  }
}

export function onBlurInput(branding, evt) {
  if (window[branding]) {
    evt.target.style.borderColor = ''
  }
}
export function onBlur2Button(branding, evt) {
  if (window[branding]) {
    evt.target.style.background = window[branding].alternate2Color
    evt.target.style.opacity = 1.0
  }
}


// WEBPACK FOOTER //
// ./src/functions/brandingChanges.js